import { FC } from 'react';
import SliderLib, { Settings } from 'react-slick';

import SliderArrow from './SliderArrow';
import SliderWrapper from './Wrapper';
import { SliderProps } from './types';

const defaultSettings: Settings = {
  dots: true,
  speed: 500,
  infinite: false,
  variableWidth: true,
  slidesToScroll: 3,
  slidesToShow: 3,
  prevArrow: <SliderArrow direction="left" />,
  nextArrow: <SliderArrow direction="right" />
};

const Slider: FC<SliderProps> = ({
  children,
  settings: newSettings,
  className
}) => {
  const settings = { ...defaultSettings, ...newSettings };

  return (
    <SliderWrapper className={className}>
      <SliderLib {...settings}>{children}</SliderLib>
    </SliderWrapper>
  );
};

export default Slider;
